import { useCallback, useState } from 'react';

import { identityHttpClient } from '@/services/http/clients/identityHttpClient';
import { UserRole } from '@/config/roles.config';

export function useGetUserRole() {
  const [isLoadingGetUserRole, setIsLoadingGetUserRole] = useState(false);
  const [apiWasAlreadyCalled, setApiWasAlreadyCalled] = useState(false);
  
  const getUserRole = useCallback(async () => {
    setApiWasAlreadyCalled(true);
    setIsLoadingGetUserRole(true);
    const requestUrl = '/user/role';
    const response = await identityHttpClient.get<UserRole>(requestUrl);
    setIsLoadingGetUserRole(false);
    return response.data;
  }, []);

  return {
    getUserRole,
    isLoadingUserRole: isLoadingGetUserRole,
    apiWasAlreadyCalled: apiWasAlreadyCalled
  } as const;
}